import { motion } from 'framer-motion';

export default function Disclaimer() {
  return (
    <>
      {/* Hero */}
      <section className="page-hero legal-hero">
        <div className="page-hero-overlay legal-hero-overlay" />
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1>Disclaimer</h1>
          </motion.div>
        </div>
      </section>

      {/* Content */}
      <section className="section">
        <div className="container">
          <div className="content-narrow mx-auto-narrow">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
            >
              <h2>No Refunds</h2>
              <p>
                All purchases are final. There are no refunds, returns, or exchanges for any products or services purchased through Fasting Carnivore. By completing your purchase, you acknowledge and agree to this no-refund policy.
              </p>

              <h2>No Guarantees</h2>
              <p>
                Fasting Carnivore makes no guarantees, representations, or warranties of any kind regarding outcomes, results, or benefits. We do not guarantee that you will achieve any particular results from using our products, services, or community.
              </p>

              <h2>Assumption of Risk</h2>
              <p>
                By purchasing our products, using our services, or participating in our community, you acknowledge and agree that:
              </p>
              <ul>
                <li>You are voluntarily choosing to participate</li>
                <li>You assume all risks associated with any dietary or lifestyle changes you choose to make</li>
                <li>Fasting Carnivore is not liable for any outcomes, health effects, or other consequences</li>
                <li>You are solely responsible for your own decisions and actions</li>
                <li>You accept full responsibility for any results or lack thereof</li>
              </ul>

              <h2>Not Medical Advice</h2>
              <p>
                The information provided on this website and in our products is for educational and informational purposes only. It is not intended as a substitute for professional medical advice, diagnosis, or treatment.
              </p>
              <p>
                The stories, experiences, and information shared are based on personal experiences and anecdotal reports. Individual results vary. What works for one person may not work for another.
              </p>

              <h2>Consult Your Healthcare Provider</h2>
              <p>
                Before making any changes to your diet, fasting practices, or lifestyle, consult with a qualified healthcare professional.
              </p>

              <h2>Who Should Not Follow This Approach</h2>
              <p>
                The dietary approaches discussed in our content may not be appropriate for everyone. You should not attempt these approaches without medical supervision if you are pregnant or breastfeeding, have a history of eating disorders, have diabetes or blood sugar regulation issues, have kidney disease or liver disease, have a history of heart disease, are taking medications that require food timing, are under 18 years of age, or have any chronic health condition.
              </p>

              <h2>Composite Stories</h2>
              <p>
                The transformation stories featured in our books and on our website are composite narratives. While they are based on real experiences and testimonials, they have been combined and edited to protect privacy. Names, identifying details, and specific circumstances have been changed or combined.
              </p>

              <h2>Emergency Situations</h2>
              <p>
                If you experience any adverse health effects, stop immediately and seek medical attention. In case of emergency, call your local emergency services.
              </p>

              <h2>External Links</h2>
              <p>
                Our website may contain links to external websites or resources. We do not endorse and are not responsible for the content, accuracy, or practices of any third-party websites.
              </p>

              <h2>Updates</h2>
              <p>
                We may update this disclaimer from time to time. The most current version will always be available on this page.
              </p>

              <h2>Contact</h2>
              <p>
                If you have questions about this disclaimer, please contact us at support@fastingcarnivore.com
              </p>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
}
